import {
  jb_text_teaser_css_default
} from "./chunk.52ZW6BUE.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  Linkable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  attachInterestEvents
} from "./chunk.AHMM4X2O.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-text-teaser/jb-text-teaser.ts
var JbTextTeaser = class extends Linkable(i) {
  constructor() {
    super(...arguments);
    this._hovering = false;
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.hasUpdated) this._attachInterestEvents();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this._detachInterestEvents?.();
    this._detachInterestEvents = void 0;
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this._attachInterestEvents();
  }
  _attachInterestEvents() {
    this._detachInterestEvents?.();
    this._detachInterestEvents = attachInterestEvents(this._activeLink);
  }
  _hoverLinkIn() {
    this._hovering = true;
  }
  _hoverLinkOut() {
    this._hovering = false;
  }
  _trackClick(event) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(event, {
      component_name: "text-teaser",
      interaction_text: this.buttonLabel
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <a
        @jb-link:clicked=${this._trackClick}
        @loseinterest=${this._hoverLinkOut}
        @interest=${this._hoverLinkIn}
        data-linkable
        ><div
          class="${e2({
      gray: !!this.hasGrayBackground
    })} wrapper"
        >
          <div class="content">
            <jb-heading variant="heading-md">${this.headline}</jb-heading>
            <p>${this.text}</p>
          </div>
          <p class="cta">
            ${this.buttonLabel}<jb-icon
              iconName="material:east"
              commonAnimation="move_right"
              class="${e2({ hover: this._hovering })}"
            ></jb-icon>
          </p></div
      ></a>
    `;
  }
};
JbTextTeaser.styles = [reset_css_default, jb_text_teaser_css_default];
__decorateClass([
  n()
], JbTextTeaser.prototype, "buttonLabel", 2);
__decorateClass([
  n({ type: Boolean })
], JbTextTeaser.prototype, "hasGrayBackground", 2);
__decorateClass([
  n({ reflect: true })
], JbTextTeaser.prototype, "headline", 2);
__decorateClass([
  n()
], JbTextTeaser.prototype, "text", 2);
__decorateClass([
  e("a")
], JbTextTeaser.prototype, "_activeLink", 2);
__decorateClass([
  r()
], JbTextTeaser.prototype, "_hovering", 2);
JbTextTeaser = __decorateClass([
  customElement("jb-text-teaser")
], JbTextTeaser);

export {
  JbTextTeaser
};
